// Solomon Portal — shadcn-flavored class merger.
//
// `cn()` combines `clsx` (conditional join, dedupe falsy values) with
// `tailwind-merge` (resolves conflicting Tailwind utility classes —
// e.g. `px-2 px-4` becomes `px-4`). This is the canonical helper that
// the shadcn family of components expects under `@/lib/utils`; we keep
// it at `src/lib/utils.ts` so the components can `import { cn } from
// '../../lib/utils'` (or the alias) without any path-aliasing setup.
//
// References:
//   - https://ui.shadcn.com/docs/installation/manual (cn helper origin)
//   - clsx: https://github.com/lukeed/clsx
//   - tailwind-merge: https://github.com/dcastil/tailwind-merge

import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
